import { FC, ReactNode } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const InfoSection = styled.div`
  background: ${({ theme }) => theme.forecast.cardBackground};
  border-radius: 8px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.forecast.cardDividerBackground};
`

const Title = styled.h3`
  margin: 0 0 8px 0;
  color: ${({ theme }) => theme.forecast.text1};
  font-size: 16px;
  font-weight: 600;
`

const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.forecast.text3};
  font-size: 14px;
  line-height: 1.5;
`

interface NiiViewContainerProps {
  title: string
  description: string
  children: ReactNode
}

export const NiiViewContainer: FC<NiiViewContainerProps> = ({
  title,
  description,
  children,
}) => {
  return (
    <Container>
      <InfoSection>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </InfoSection>
      {children}
    </Container>
  )
}
